// extracted by mini-css-extract-plugin
module.exports = {"intro":"styles_intro__zkIY1","title":"styles_title__J0bjh"};